export default __webpack_public_path__ + "static/media/cropsieFacebook-1200x630.e8fb76d3.jpg";